module.exports = __webpack_public_path__ + "static/media/slider-image-2.49f988c1.jpg";